import '../assets/css/bootstrap-iso.min.css'
import '../assets/css/style.css'
import "bootstrap/dist/js/bootstrap.bundle";

import ProductList from './Components/ProductList'
import { useGetShopQuery } from '../Redux/Apis/shopApi'
import Error from "../Components/Error";
import Loading from "../Components/Loading";
import { Link } from 'react-router-dom'
import Breadcrumb from './Components/Breadcrumb'
import CartIcon from './Components/CartIcon';
import { useState } from 'react';
import Cart from './Components/Cart';

export default function ShopApp(){
    const [showCart, setShowCart] = useState(false);

    const { data,
            isLoading,
            isSuccess,
            isError,
            error,
        } = useGetShopQuery()

    if(isLoading)
        return <Loading/>
    
    else if(isError)
        return <Error data={error}/>
    
    else if(isSuccess)
        return(
            <>
            {data && data.status === "ACTIVE" ? 
            <>
                <CartIcon showCart={setShowCart}/>
                <div className='bootstrap-iso border-top border-0' style={{boxShadow: "inset 0 7px 9px -7px rgba(171, 116, 66,0.4)"}}>
                    {data.banner && <Breadcrumb name={data.name} image={data.banner} cat={"All Products"} product={''}/>}
                    <ProductList products={data.Products} categories={data.ProductCategories}/>
                </div>
                {showCart && <Cart onClose={() => setShowCart(false)}/> }
            </>
             :
            <div className='bootstrap-iso text-center'>
                <div className="alert alert-info my-5 py-5" role="alert">
                    <p>
                        Shop is disabled.    
                    </p>
                    <Link to="/" className='btn btn-primary'>Return Home</Link> 
                </div>
            </div>
            }
            </>
        )
}